import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { FiUpload } from "react-icons/fi";
import Dropzone from "react-dropzone";

import { Logo, NextStepButton } from "components";
import { UPDATE_INPUT, MOVE_TAB } from "actions";
import { formatBytes } from "functions";

class SingleInvoiceFile extends Component {
  state = {
    fileError: false
  };
  onFileDrop = files => {
    this.props.updateInput({ name: "singleInvoiceFile", value: files[0] });
    this.setState({
      fileError: false
    });
  };
  render() {
    const state = this.state;
    const props = this.props;

    const subTitle = props.forceSingleInvoice ?
      props.domain.Strings.tabSingleInvoiceFileSubTitleForced :
      props.domain.Strings.tabSingleInvoiceFileSubTitle;

    return (
      <div className="form_steps test_single_invoice_file">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <div className="form_content">
              <div className="form_content">
                <h2 className="form_content--title">
                  {props.domain.Strings.tabSingleInvoiceFileTitle}
                </h2>

                <Box>
                  <BoxInner bg={props.domain.BaseColour}>
                    <BoxTitle>
                      {" "}
                      {subTitle}
                    </BoxTitle>
                    <div>{props.domain.Strings.tabSingleInvoiceFileLongDescription}</div>
                  </BoxInner>
                </Box>
                <NextStepButton
                  onClick={this.props.moveToNextTab}
                  text={props.domain.Strings.tabSingleInvoiceFileNextBtn}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) =>
      dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () =>
      dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleInvoiceFile);

const Box = styled.div`
  background-color: #fff;
  border: 1px solid #e3e3e3;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
`;
const BoxInner = styled.div`
  padding: 25px;
  text-align: center;
  div.dropzone {
    width: 100%;
    background: #eef5ff;
    color: #555555;
    border: 2px dotted #2f7de1;
    height: 200px;
    text-align: center;
    padding-top: 35px;
    button {
      padding: 5px 10px;
      margin-top: 10px;
      background-color: ${props => props.bg};
      border-radius: 3px;
      border: 2px solid ${props => props.bg};
      font: inherit;
      color: #fff;
      &:hover {
        background-color: transparent;
        cursor: pointer;
        color: ${props => props.bg};
      }
    }
    p {
      margin-bottom: 10px;
      height: 20px;
      color: #555555;
      font-size: 16px;
      line-height: 12px;
      font-weight: 400;
    }
  }
`;

const BoxTitle = styled.div`
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
`;
/*
const BoxOptions = styled.div`
  border-top: 1px solid #e3e3e3;
  padding: 10px;
  text-align: right;
`;
*/
